export default {
  defaultUrl: (remoteId: string, source: string): string => {
    return `https://www.${source}.com/embed/${remoteId}`;
  },
  vimeoUrl: (remoteId: string): string => {
    return `https://player.vimeo.com/video/${remoteId}`;
  },
  yahooUrl: (remoteId: string): string => {
    return `https://sports.yahoo.com/video/${remoteId}?format=embed`;
  }
};
